import React, { forwardRef } from 'react';
import TextContainer from '@components/textContainer/TextContainer';
import { Modal, Spin } from 'antd';
import './styles.scss';
import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import { FixedRatios } from '@model';

function TextContainerModal(
  {
    visible,
    loading,
    ratio = FixedRatios.BANNER,
    onOk,
    onCancel,
    initialValues,
    initialColumnRatio,
  },
  ref,
) {
  return (
    <Modal
      visible={visible}
      className="text-container-modal"
      okText="Save"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={onOk}
      cancelButtonProps={{
        className: 'cancel-btn',
      }}
      destroyOnClose
    >
      <h3>Edit Text Container</h3>
      <Spin spinning={loading}>
        <div
          // ratio={ratio}
          className="text-container-modal-ratio powerbi-fullscreen-div fix-ratio-div"
          // id={`fullscreen-${identifier}`}
        >
          <TextContainer
            ref={ref}
            editable={visible}
            initialValues={initialValues}
            initialColumnRatio={initialColumnRatio}
          />
        </div>
      </Spin>
    </Modal>
  );
}

export default forwardRef(TextContainerModal);
